import { render, staticRenderFns } from "./class-detail.vue?vue&type=template&id=5d1b30be"
import script from "./class-detail.vue?vue&type=script&lang=js"
export * from "./class-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports